module.exports = __webpack_public_path__ + "01_mid_yellow.bdbfbbcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/01_mid_yellow.png
// module id = eBw3
// module chunks = 0